import addPolyfills from './polyfills';
import initMenu from './menu';
import initForms from './forms';

export { addPolyfills, initMenu, initForms };
